import { TextInput, Textarea } from "@centricsoftware/design-system";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useAttributeDefinitionStore } from "./AttributeDefinitionStore";

const AttributeDefinitionSectionValidationExpression: FunctionComponent = observer(() => {
	const { 
		attrValidationExpression,
		attrValidationExpressionError,
		attrValidationErrorMessage,
		locale,
		onChangeValidationErrorMessage,
		onChangeValidationExpression,
	} = useAttributeDefinitionStore();

	const {
		helperTextValidationErrorMessageRes,
		labelValidationErrorMessageRes,
		labelValidationExpressionRes,
	} = locale;
	
	return (
		<>
			<Textarea
				error={!!attrValidationExpressionError}
				errorMessage={attrValidationExpressionError}
				labelRes={labelValidationExpressionRes}
				minRows={1}
				onChange={onChangeValidationExpression}
				value={attrValidationExpression}
			/>
			<TextInput
				helperTextRes={helperTextValidationErrorMessageRes}
				labelRes={labelValidationErrorMessageRes}
				onChange={onChangeValidationErrorMessage}
				value={attrValidationErrorMessage}
			/>
		</>
	);
});

export default AttributeDefinitionSectionValidationExpression;